export const MiniLogoStone = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="52"
    height="14"
    viewBox="0 0 52 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_35339_1010)">
      <g clipPath="url(#clip1_35339_1010)">
        <mask
          id="mask0_35339_1010"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="52"
          height="14"
        >
          <path
            d="M2.65009 9.58367C2.76028 10.5739 3.53311 11.1897 4.68171 11.1897C5.63125 11.1897 6.29339 10.7277 6.29339 10.1114C6.29339 7.84509 0.309238 10.0674 0.309238 5.40269C0.309238 3.44453 2.00927 2.05812 4.2836 2.05812C6.95552 2.05812 8.76625 3.48855 8.87644 5.66682H6.20451C6.07198 4.72062 5.21079 4.21464 4.37195 4.21464C3.53311 4.21464 2.91464 4.58856 2.91464 5.2929C2.91464 7.55921 9.00897 4.98475 9.00897 10.0016C9.00897 12.1141 7.28659 13.5 4.68119 13.5C2.07579 13.5 0.110182 11.9815 0 9.58367H2.65009Z"
            fill="black"
          />
          <path
            d="M51.1875 9.5614C50.7457 11.9598 48.6263 13.5 45.8878 13.5C42.112 13.5 40.1687 10.5516 40.1687 7.75705C40.1687 4.96248 41.8911 2.05812 45.667 2.05812C49.4428 2.05812 51.1652 4.94073 51.1652 7.47065C51.1652 7.8886 51.1433 8.2185 51.121 8.46087H43.1276C43.3484 10.0228 44.3422 10.9913 45.8878 10.9913C47.1243 10.9913 47.9413 10.5071 48.184 9.56088H51.187L51.1875 9.5614ZM43.1717 6.52497H48.0956C48.0073 5.2929 47.1461 4.30268 45.667 4.30268C44.2756 4.30268 43.4368 4.98475 43.1717 6.52497Z"
            fill="black"
          />
          <path
            d="M33.9798 2.05864C30.1318 2.05864 28.7467 4.55904 28.7467 6.89734V13.3244H31.838V5.34521C31.838 5.03654 32.0891 4.7864 32.3988 4.7864H35.5614C35.8711 4.7864 36.1221 5.03654 36.1221 5.34521V13.3244H39.2135V6.89734C39.2135 4.55904 37.8279 2.05864 33.9798 2.05864Z"
            fill="black"
          />
          <path
            d="M16.0513 2.23472H13.0701V0H10.0011V9.29727C10.0011 11.8717 11.657 13.3239 14.2187 13.3239H16.0513V10.7495L13.6382 10.736C13.3284 10.736 13.0774 10.4858 13.0774 10.1772L13.0701 4.7864H16.0513V2.23472Z"
            fill="black"
          />
          <g clipPath="url(#clip2_35339_1010)">
            <mask
              id="mask1_35339_1010"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="16"
              y="2"
              width="12"
              height="12"
            >
              <path
                d="M22.1625 11.4353L18.9914 8.26399C18.779 8.05158 18.7773 7.70944 18.9846 7.49407L16.6494 6.75424C16.5447 7.27318 16.5104 7.81798 16.5596 8.37804C16.8008 11.1266 19.046 13.3156 21.7996 13.4886C23.3564 13.5865 24.7863 13.0497 25.8585 12.1136C25.9068 12.0717 25.8551 11.9953 25.7987 12.0254C25.4418 12.2179 24.9487 12.3778 24.2975 12.3778C23.0477 12.3778 22.1625 11.4353 22.1625 11.4353Z"
                fill="black"
              />
              <path
                d="M22.1625 2.25C20.7457 2.25 19.4518 2.77487 18.4627 3.63977C18.4148 3.68174 18.4673 3.75721 18.5233 3.72711C18.8807 3.5342 19.3746 3.37309 20.0275 3.37309C21.3383 3.37309 22.1625 4.31473 22.1625 4.31473L25.3337 7.48601C25.5482 7.70054 25.5486 8.04819 25.3345 8.26314L27.6476 9.11998C27.7383 8.71933 27.7875 8.303 27.7875 7.87521C27.7875 4.76837 25.2692 2.25 22.1625 2.25Z"
                fill="black"
              />
              <path
                d="M25.3351 8.26305C25.3351 8.26305 25.7141 7.7458 26.0787 7.83526C27.7334 8.241 27.7825 7.62158 27.7825 7.62158C27.7825 7.62158 28.0157 11.7515 24.9251 11.7515C23.6143 11.7515 22.7901 10.8098 22.7901 10.8098L25.3351 8.26305Z"
                fill="url(#paint0_linear_35339_1010)"
              />
              <path
                d="M18.9904 7.48768C18.9904 7.48768 18.6113 8.00492 18.2467 7.91546C16.5921 7.50973 16.5429 8.12914 16.5429 8.12914C16.5429 8.12914 16.3097 3.99927 19.4003 3.99927C20.7112 3.99927 21.5353 4.9409 21.5353 4.9409L18.9904 7.48768Z"
                fill="url(#paint1_linear_35339_1010)"
              />
            </mask>
            <g mask="url(#mask1_35339_1010)">
              <rect
                x="16.5375"
                y="2.25"
                width="11.25"
                height="11.25"
                fill="#004921"
              />
            </g>
          </g>
        </mask>
        <g mask="url(#mask0_35339_1010)">
          <rect width="51.1875" height="13.5" fill="#004921" />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_35339_1010"
        x1="23.8339"
        y1="11.8464"
        x2="26.6494"
        y2="9.03097"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopOpacity="0" />
        <stop offset="0.15" stopOpacity="0.15" />
        <stop offset="0.51" stopOpacity="0.61" />
        <stop offset="0.8" stopOpacity="0.9" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_35339_1010"
        x1="20.4907"
        y1="3.9043"
        x2="17.6751"
        y2="6.71976"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopOpacity="0" />
        <stop offset="0.15" stopOpacity="0.15" />
        <stop offset="0.51" stopOpacity="0.61" />
        <stop offset="0.8" stopOpacity="0.9" />
        <stop offset="1" />
      </linearGradient>
      <clipPath id="clip0_35339_1010">
        <rect width="51.1875" height="13.5" fill="white" />
      </clipPath>
      <clipPath id="clip1_35339_1010">
        <rect width="51.1875" height="13.5" fill="white" />
      </clipPath>
      <clipPath id="clip2_35339_1010">
        <rect
          width="11.25"
          height="11.25"
          fill="white"
          transform="translate(16.5375 2.25)"
        />
      </clipPath>
    </defs>
  </svg>
);
